import React, { useEffect, useState } from "react";
import { useLocalSearchParams } from "expo-router";
import { View, StyleSheet, Text, ScrollView } from "react-native";
import { doc, onSnapshot } from "firebase/firestore";

import { db } from "@/lib/firebase";
import type { Business } from "@/lib/types";
import BusinessCardResponsive from "@/components/business/BusinessCardResponsive";

export default function AdminBusinessFullPreviewScreen() {
  const { id } = useLocalSearchParams<{ id: string }>();
  const businessId = typeof id === "string" ? id : "";

  const [business, setBusiness] = useState<Business | null>(null);

  useEffect(() => {
    if (!businessId) return;

    const ref = doc(db, "businesses", businessId);
    const unsub = onSnapshot(ref, (snap) => {
      if (!snap.exists()) {
        setBusiness(null);
        return;
      }
      setBusiness({ id: snap.id, ...(snap.data() as Omit<Business, "id">) });
    });

    return () => unsub();
  }, [businessId]);

  if (!businessId) {
    return (
      <View style={styles.center}>
        <Text style={styles.h1}>Missing business id</Text>
      </View>
    );
  }

  if (!business) {
    return (
      <View style={styles.center}>
        <Text style={styles.h1}>Loading full preview…</Text>
      </View>
    );
  }

  return (
    <View style={styles.page}>
      <View style={styles.top}>
        <Text style={styles.h1} numberOfLines={1}>
          Full Preview • {business.name ?? "Business"}
        </Text>
        <Text style={styles.badge}>{business.status ?? "—"}</Text>
      </View>

      <ScrollView contentContainerStyle={{ paddingBottom: 24 }}>
        {/* Admin preview: no share/save/download handlers */}
        <BusinessCardResponsive business={business} />
      </ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  page: { flex: 1, padding: 12, gap: 10 },
  top: { flexDirection: "row", alignItems: "center", justifyContent: "space-between", gap: 10 },
  h1: { fontSize: 16, fontWeight: "900", flex: 1 },
  badge: { paddingHorizontal: 10, paddingVertical: 6, borderRadius: 999, borderWidth: 1, borderColor: "#ddd" },
  center: { flex: 1, justifyContent: "center", alignItems: "center" },
});